//Library
import React, { Component } from 'react';
import { withRouter } from "react-router";
import AOS from 'aos';
//component
import Header from '../Header';
import HeaderByLogin from '../HeaderByLogin';
import Footer from '../Footer';
//redux
import { connect } from 'react-redux';
import { getErrorMsg, setErrorMsgByCookie } from '../../action/anueInfoAction';

class Layout extends Component {

  constructor(props) {
    super(props);
    // eslint-disable-next-line no-extend-native
    Date.prototype.yyyymmdd = function () {
      var mm = this.getMonth() + 1; // getMonth() is zero-based
      var dd = this.getDate();

      return [this.getFullYear(),
      (mm > 9 ? '' : '0') + mm,
      (dd > 9 ? '' : '0') + dd
      ].join('');
    };
  }
  getHeader() {
    let pageName = this.props.location.pathname.replace("/", "");
    if (pageName === "Purchase" || pageName === "TSR") {
      return <HeaderByLogin />
    }
    else {
      return <Header />
    }
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    AOS.init({
      duration: 500,
      easing: 'ease-out-back',
      delay: 100
    });
    this.checkErrorMsg();
  }

  /*
取得錯誤碼
判斷Redux內沒有 則抓取cookie看看
1.如cookie沒有，則直接callApi取得，存到cookie 並且給Redux
2.如cookie有，則判斷日期
  (一)如日期相同，就直接給Redux
  (二)如日期不相同，則直接callApi取得，存到cookie 並且給Redux
*/
  checkErrorMsg() {
    let data = JSON.parse(localStorage.getItem("ErrorMsg"));
    if (data == null)
      this.props.getErrorMsg();
    else if (data.date !== new Date().yyyymmdd())
      this.props.getErrorMsg();
    else
      this.props.setErrorMsgByCookie(data);
  }

  render() {
    const { main: Main } = this.props;
    return <div>
      {this.getHeader()}
      <Main />
      <Footer />
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    errorMsg: state.anueInfoState.errorMsg
  };
}

export default connect(mapStateToProps, { getErrorMsg, setErrorMsgByCookie })(withRouter(Layout));
